import React from "react";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import { useDispatch } from "react-redux";
import useSWRMutation from "swr/mutation";

import {
  setSnackbarMode,
  setSnackbarTitle,
} from "../../../../redux/features/settingSlice";
import { fetcherPost } from "../../../../services/fetcher";
import Logout from "./../../../../utils/Logout";

const LogoutBtn = ({ StyleMenuItem, setAnchorEl }) => {
  const dispatch = useDispatch();
  const refreshToken = JSON.parse(localStorage.getItem("rt")) || null;
  const tokenStorage = JSON.parse(localStorage.getItem("token")) || null;

  const { trigger } = useSWRMutation(
    [`${process.env.REACT_APP_API}/auth/logout/`, tokenStorage],
    fetcherPost
  );

  const handleSubmit = async () => {
    dispatch(setSnackbarMode(true));
    dispatch(setSnackbarTitle("You are logged out the application"));

    Logout(dispatch);
    setAnchorEl(null);
    try {
      await trigger({ refresh: refreshToken });
    } catch (e) {}
  };

  return (
    <StyleMenuItem onClick={handleSubmit}>
      <LogoutRoundedIcon style={{ marginTop: "-3px", marginRight: "8px" }} />
      Logout
    </StyleMenuItem>
  );
};

export default LogoutBtn;
